module.exports = __webpack_public_path__ + "img/pdf.4b8ae1b0.svg";